import { Box } from '@mui/material';
import { ArcElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip, } from 'chart.js';
import { merge } from 'lodash';
import React, { forwardRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
ChartJS.register(Title, Tooltip, Legend, CategoryScale, LinearScale, ArcElement);
export const DoughnutChart = forwardRef(({ data, options = {}, containerProps }, ref) => {
    const defaultBoxProps = merge({
        sx: { flex: '1 1 auto', maxWidth: '100%' },
    }, containerProps);
    const defaultDoughnutOptions = merge({
        responsive: true,
        maintainAspectRatio: false,
        cutout: '75%',
        plugins: {
            legend: {
                display: false,
            },
        },
    }, options);
    return (React.createElement(Box, { ...defaultBoxProps },
        React.createElement(Doughnut, { ref: ref, data: data, options: defaultDoughnutOptions })));
});
